export const SKIN_KEYS = {
  DATA_SUMMARY: 'pl_datasummary',
  INDICATOR: 'pl_indicator',
};

export const SKIN_OPTIONS = [
  { key: SKIN_KEYS.INDICATOR, text: 'Indicator' },
  { key: SKIN_KEYS.DATA_SUMMARY, text: 'Data Summary' },
];

export const S3_IMAGE_BUCKET_URL =
  'https://api.apiflash.com/v1/urltoimage?access_key=8d4ac0f76cbc45d28e06063667d7a3d4&element=.AtlasWidgetMain';

export const FieldAttributeType = {
  LABEL: 'label',
  COLOR: 'color',
};

export const DisplayGroupBreakdownType = {
  MAP: 'map',
};

export default {
  SKIN_OPTIONS,
  FieldAttributeType,

  DisplayGroupBreakdownType,
};
